import { NavLink } from "@remix-run/react";

export type NavItem = Readonly<{
  name: string;
  url: string;
}>;

const links: NavItem[] = [
  {
    name: "Terms of Service",
    url: "/legal/terms",
  },
  {
    name: "Privacy Policy",
    url: "/legal/privacy",
  },
  {
    name: "Disclosures",
    url: "/legal/disclosures",
  },
  {
    name: "Business User Agreement",
    url: "/legal/business-user-agreement",
  },
];

export function SideNav(): JSX.Element {
  return (
    <div className="h-fit md:max-w-fit mb-6 md:mb-0 text-sm not-prose sidenav">
      <nav className="space-y-2">
        {links.map((l) => {
          return (
            <NavLink
              className="btn nav"
              prefetch="intent"
              to={`${l.url}`}
              key={l.name}
            >
              {l.name}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
